import Button from 'components/Button';
import styled from 'styled-components';
import tw from 'twin.macro';
import { StyledRedeemCardProps } from './RedeemCard.types';

export const RedeemCardWrapper = styled.div<StyledRedeemCardProps>`
  ${tw`w-full max-w-[11.313rem] h-[14.938rem] max-h-[14.938rem] mb-5
    flex flex-col rounded-lg border-2 border-solid border-black relative bg-[#E1FFF2]`};
  ${({ state }) =>
    state === 'onRedeem' && tw`bg-[#FEE1FF] [&>section]:bg-[#FEE1FF]`}
  ${({ state }) =>
    state === 'redeemed' && tw`[&>span]:(bg-black bg-opacity-70)`}
  ${({ state }) =>
    state === 'expired' &&
    tw`[&>span]:(bg-black bg-opacity-70 [&>p]:text-[#FE4A4F])`}
`;

export const RedeemImage = tw.img`w-full min-h-[8.625rem] border-b-2 border-solid border-black rounded-t-[5px]
    bg-cover object-cover
`;

export const RedeemInfo = tw.section`w-full h-full flex flex-col justify-start items-start gap-2 px-3 py-2 bg-[#E1FFF2] rounded-b-[5px]`;

export const RedeemCoinsWrapper = tw.div`w-[3.906rem] h-[1.438rem] rounded-full bg-white 
flex justify-center items-center gap-1 font-bold text-[16px]
`;

export const RedeemCoins = tw.img`w-[1.406rem] h-[0.938rem] object-fill`;

export const RedeemName = tw.div`text-[14px] font-bold text-darkGray capitalize`;

export const RedeemAction = styled(Button)`
  ${tw`absolute bottom-0 left-2 right-2 translate-y-1/2 h-[3.062rem] rounded-[14px] [&>div]:(h-[3.062rem] rounded-[14px] border-[3px]  border-solid)`}
`;

export const RedeemActionCount = tw.div`w-full h-full flex justify-center items-center gap-2 font-bold text-[#FE4A4F]
    text-[16px] capitalize [&>img]:(w-5 h-5)`;

export const RedeemReduction = tw.div`w-[5.188rem] h-[1.438rem] rounded-full bg-[#FEE1FF] px-1 text-[14px] font-bold
        flex justify-center items-center absolute top-2 left-2
`;

export const RedeemLock = tw.span`w-full h-full flex flex-col gap-2 justify-center items-center
                             absolute z-30 bg-[#161F21] bg-opacity-70`;

export const RedeemLockIcon = tw.img`w-[2.438rem] h-[2.438rem] object-contain`;

export const RedeemLockText = tw.p`text-[14px] font-bold text-[#00D566] text-center`;
